// User ID in Subgraph Studio for account 0x905Cd35100ad357699B579995825a56C6Ce1e07b
export const SUBGRAPH_STUDIO_USER_ID = 112_500;

/**
 * EOA wallet formerly used for pre-paying Sablier fees.
 *
 * @deprecated Deprecated on June 9, 2026 after the in-app billing system was removed. Kept for package compatibility.
 */
export const BILLING_ADDRESS = "0xA6a4c1D99312978A3207fF1a28b958e5efAA0a42";
